import { isEmpty } from 'lodash';
import { combineReducers } from 'redux';

import { RESET_ACCOUNT_USER } from '../constants';
import { REQUEST_USER_BALANCE, RECEIVE_USER_BALANCE, FAILURE_USER_BALANCE } from './constants';

const credit = (state = 0, action) => {
    switch (action.type) {
        case RECEIVE_USER_BALANCE:
            if (isEmpty(action.response.payload)) {
                return 0;
            }
            return action.response.payload.value;
        case RESET_ACCOUNT_USER:
            return 0;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_USER_BALANCE:
            return true;
        case FAILURE_USER_BALANCE:
        case RECEIVE_USER_BALANCE:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_USER_BALANCE:
            return action.response.message;
        case REQUEST_USER_BALANCE:
        case RECEIVE_USER_BALANCE:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    credit,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/account/balance/reducer.js